import React from "react";
import ReactDom from "react-dom";
import App from "./app"
import "./index.css"
import "./i18n"

ReactDom.render(<App/> , document.querySelector("#root"))